import Vue from "vue";
import components from "@/components";

Vue.use(components);
